const customisationData = $('#pageCustomisation').data('customisations');
export default function onCustomisation (type, callback) {
  if (!customisationData) { return }

  for (var i = 0; i < customisationData.length; i += 1) {
    var data = customisationData[i];
    if (data.key == type) { callback(data) }
  }
}
